// extracted by mini-css-extract-plugin
export default {"label":"FormInputTextWithLabelSpecial_label__PDxGo","input":"FormInputTextWithLabelSpecial_input__fly8e"};